<template>
  
    <nav class="navbar navbar-expand-lg fixed-top navbar-light border-bottom" style="background-color: #e3f2fd; border-color: grey;">
  <!-- Navbar content -->
  <div class="container-fluid">
    <a class="navbar-brand" href="#">Mr Khusan</a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse justify-content-end" id="navbarSupportedContent">
      <ul class="navbar-nav mb-2 mb-lg-0 justify-content-end">
        <li class="nav-item">
          <router-link to="./"><a class="nav-link active" aria-current="page" href="#">Home</a></router-link>
        </li>
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            Portfolio
          </a>
          <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
            <li><router-link to="./robotics"><a class="dropdown-item" href="#">Robotics</a></router-link></li>
            <li><router-link to="./programing"><a class="dropdown-item" href="#">Programming</a></router-link></li>
            <li><router-link to="./mobilegames"><a class="dropdown-item" href="#">Mobile Games</a></router-link></li>
            <li><router-link to="./songs"><a class="dropdown-item" href="#">Songs</a></router-link></li>
            <li><router-link to="./poesy"><a class="dropdown-item" href="#">Books</a></router-link></li>
            <li><router-link to="./cartoon"><a class="dropdown-item" href="#">Cartoons</a></router-link></li>
            <li><router-link to="./clips"><a class="dropdown-item" href="#">Clips</a></router-link></li>
            <li><hr class="dropdown-divider"></li>
            <li><router-link to="./articles"><a class="dropdown-item" href="#">Articles</a></router-link></li>
          </ul>
        </li>
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            Projects
          </a>
          <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
            <li><a class="dropdown-item" href="https://drive.proton.me/urls/RPB441WKM0#FhYm809jkAKM">ASLify EchoVision</a></li>
            <li><a class="dropdown-item" href="https://drive.proton.me/urls/4DSMEVMYPG#XC7tf5t0nQ2B">KAI Drone</a></li>
            
            <li><a class="dropdown-item" href="https://drive.proton.me/urls/3TTFFN52NC#nO0e0e6XB8Tx">CyberView</a></li>
          </ul>
        </li>
        <li class="nav-item">
          <router-link to="./about"><a class="nav-link active" href="#" aria-current="page">About</a></router-link>
        </li>
        <li class="nav-item">
          <router-link to="./volunteer"><a class="nav-link active" aria-current="page" href="#">Volounteer working</a></router-link>
        </li>
        <li class="nav-item">
          <router-link to="./clips"><a class="nav-link active" href="#" aria-current="page">Clips</a></router-link>
        </li>
      </ul>
      <!--<form class="d-flex">
        <input class="form-control me-2" type="search" placeholder="Search" aria-label="Search">
        <button class="btn btn-outline-success" type="submit">Search</button>
      </form>-->
    </div>
  </div>
  <hr>
</nav>

  
  <router-view>
  </router-view>
  <footer class="text-center text-lg-start bg-body-tertiary text-muted">
    <!-- Section: Social media -->
    <section class="d-flex justify-content-center justify-content-lg-between p-4 border-bottom">
      <!-- Left -->
      <div class="me-5 d-none d-lg-block">
        <span>The Science is Live, Past, Present, and Future.</span>
      </div>
      <!-- Left -->
  
      <!-- Right -->
       <div>
        <a
        data-mdb-ripple-init
          class="btn text-white btn-floating m-1"
          style="background-color: #3b5998;"
          href="https://www.facebook.com/p/Khusan-Oybekov-61566887498233/?locale=ru_RU"
          role="button"
          ><i class="bi bi-facebook"></i></a>
          <a
          data-mdb-ripple-init
          class="btn text-white btn-floating m-1"
          style="background-color: #55acee;"
          href="https://x.com/KOybekov"
          role="button"
          ><i class="bi bi-twitter-x"></i></a>
  
        <!-- Google -->
         <a
          data-mdb-ripple-init
          class="btn text-white btn-floating m-1"
          style="background-color: #dd4b39;"
          href="#!"
          role="button"
          ><i class="bi bi-google"></i></a>
  
         <!--Instagram -->
       <a
          
          class="btn text-white btn-floating m-1"
          style="background-color: #ac2bac;"
          href="https://www.instagram.com/udzum1/"
          role="button"
          ><i class="bi bi-instagram"></i></a>
  
         <!--Whatsapp -->
         <a
          data-mdb-ripple-init
          class="btn text-white btn-floating m-1"
          style="background-color: green"
          href="#!"
          role="button"
          ><i class="bi bi-whatsapp"></i></a>
         <!--Github -->
         <a
          data-mdb-ripple-init
          class="btn text-white btn-floating m-1"
          style="background-color: #333333;"
          href="https://github.com/cyriu77?tab=repositories"
          role="button"
          ><i class="bi bi-github"></i
        ></a>
           <!--Skype -->
        <a
          data-mdb-ripple-init
          class="btn text-white btn-floating m-1"
          style="background-color: blue;"
          href="https://github.com/cyriu77?tab=repositories"
          role="button"
          ><i class="bi bi-skype"></i></a>
          </div>
      <!-- Right -->
    </section>
    <!-- Section: Social media -->
  
    <!-- Section: Links  -->
    <section class="">
      <div class="container text-center text-md-start mt-5">
        <!-- Grid row -->
        <div class="row mt-3">
          <!-- Grid column -->
          <div class="col-md-3 col-lg-4 col-xl-3 mx-auto mb-4">
            <!-- Content -->
            <h6 class="text-uppercase fw-bold mb-4">
              <i class="fas fa-gem me-3"></i>Mr Khusan
            </h6>
            <p>
              Until I brief I will try and never give up.  
            </p>
          </div>
          <!-- Grid column -->
  
          <!-- Grid column -->
          <div class="col-md-2 col-lg-2 col-xl-2 mx-auto mb-4">
            <!-- Links -->
            <h6 class="text-uppercase fw-bold mb-4">
              Products
            </h6>
            <p>
              <router-link to="./mobilegames"><a href="#!" class="text-reset">Mobile Games</a></router-link>
            </p>
            <p>
              <router-link to="./songs"><a href="#!" class="text-reset">Songs</a></router-link>
            </p>
            <p>
              <router-link to="./poesy"><a href="#!" class="text-reset">Poesy</a></router-link>
            </p>
            <p>
              <router-link to="./robotics"><a href="#!" class="text-reset">Robots</a></router-link>
            </p>
          </div>
          <!-- Grid column -->
  
          <!-- Grid column -->
          <div class="col-md-3 col-lg-2 col-xl-2 mx-auto mb-4">
            <!-- Links -->
            <h6 class="text-uppercase fw-bold mb-4">
              Useful links
            </h6>
            <p>
              <router-link to="./about"><a href="#!" class="text-reset">About</a></router-link>
            </p>
            <p>
              <router-link to="./cartoon"><a href="#!" class="text-reset">Cartoons</a></router-link>
            </p>
            <p>
              <router-link to="./volunteer"><a href="#!" class="text-reset">Volunteer Work</a></router-link>
            </p>
            <p>
              <router-link to="./articles"><a href="#!" class="text-reset">Articles</a></router-link>
            </p>
          </div>
          <!-- Grid column -->
  
          <!-- Grid column -->
          <div class="col-md-4 col-lg-3 col-xl-3 mx-auto mb-md-0 mb-4">
            <!-- Links -->
            <h6 class="text-uppercase fw-bold mb-4">Contact</h6>
            <p><i class="fas fa-home me-3"></i> Tashkent, Uz</p>
            <p>
              <i class="fas fa-envelope me-3"></i>
              xusanoybekov094@protonmail.com
            </p>
            <p><i class="fas fa-phone me-3"></i> + 998 99 887 57 48</p>
            <p><i class="fas fa-print me-3"></i> + 998 94 722 91 18</p>
          </div>
          <!-- Grid column -->
        </div>
        <!-- Grid row -->
      </div>
    </section>
    <!-- Section: Links  -->
  
    <!-- Copyright -->
    <div class="text-center p-4" style="background-color: rgba(0, 0, 0, 0.05);">
      © 2025 Copyright:
      <a class="text-body" href="https://github.com/cyriu77?tab=repositories">Mr. Khusan</a>
    </div>
    <!-- Copyright -->
  </footer>
  
</template>
<script>

</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
